// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"11":"22fae203894be1fc","1175":"f3bc9feaf79e6532","1763":"525adbe84b8214da","2550":"dddff60e235b8772","3533":"bcafcd654973699e","7273":"e1ca38b5e00b1213","9220":"925dcb6277d36ce1"}[chunkId] + ".js";
};